// extracted by mini-css-extract-plugin
module.exports = {"text":"KtOrderCardItems_text__2Kmya","extraFood":"KtOrderCardItems_extraFood__1v3sm","extraFood-ltr":"KtOrderCardItems_extraFood-ltr__3ZgEd","bold":"KtOrderCardItems_bold__3q6-k"};